import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationUserDTO, StaticRole, UserOrganizationStatus, UserRole } from '@markant-platform/shared/user/model';
import {
  MemberDetailsDemoConfig,
  OrganizationMemberDetailsComponent,
} from '@markant-platform/shared/organization/feature';
import { UsageRight } from '@markant-platform/usage-right/model';
import { Group } from '@markant-platform/authorizer/model';
import { TranslocoService } from '@jsverse/transloco';
import { SalutationType } from 'data-model';

@Component({
  selector: 'markant-platform-organization-member-detail-demo',
  standalone: true,
  imports: [CommonModule, OrganizationMemberDetailsComponent],
  templateUrl: './organization-member-detail-demo.component.html',
  styleUrl: './organization-member-detail-demo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationMemberDetailDemoComponent {
  @Input() currentStep!: number;

  baseKey = 'guidedTour.tours.guided-tour-oa-admin-area.section3.step8';

  constructor(private translocoService: TranslocoService) {}

  demoConfig: MemberDetailsDemoConfig = {
    user: {
      salutation: SalutationType.m,
      phone: '123456789',
      firstname: 'Max',
      lastname: 'Mustermann',
      language: 'de-de',
      email: 'max.muster@dto.de',
      roles: [StaticRole.ORGANIZATION_MEMBER],
      platformRoles: [StaticRole.ORGANIZATION_MEMBER],
      userOrganizationStatus: UserOrganizationStatus.INVITED,
    } as OrganizationUserDTO,

    // Service roles for the user
    usageRights: [
      {
        cartridgeVariantId: 'demo-cartridge-id-1',
        cartridgeName: this.translocoService.translate(this.baseKey + '.userService1'),
        cartridgeVariantName: '',
      },
      {
        cartridgeVariantId: 'demo-cartridge-id-2',
        cartridgeName: this.translocoService.translate(this.baseKey + '.userService2'),
        cartridgeVariantName: '',
      },
    ] as UsageRight[],
    cartridgeRoleAssignments: new Map([
      [
        'demo-cartridge-id-1',
        [{ localizedDisplayName: this.translocoService.translate(this.baseKey + '.administration') }] as UserRole[],
      ],
      [
        'demo-cartridge-id-2',
        [{ localizedDisplayName: this.translocoService.translate(this.baseKey + '.viewer') }] as UserRole[],
      ],
    ]),

    // Service roles for the group
    userGroups: [{ id: 'demoGroupId1', displayName: 'Einkauf' }] as Group[],
    groupRoleAssignments: {
      demoGroupId1: [
        {
          cartridgeId: 'group-demo-cartridge-id-1',
          localizedCartridgeName: this.translocoService.translate(this.baseKey + '.groupService1'),
          roles: [
            {
              groupId: 'demoGroupId1',
              localizedDisplayName: this.translocoService.translate(this.baseKey + '.viewer'),
            },
          ] as UserRole[],
        },
        {
          cartridgeId: 'group-demo-cartridge-id-2',
          localizedCartridgeName: this.translocoService.translate(this.baseKey + '.groupService2'),
          roles: [
            {
              groupId: 'demoGroupId1',
              localizedDisplayName: this.translocoService.translate(this.baseKey + '.viewer'),
            },
          ] as UserRole[],
        },
      ],
    },
  };
}
